import { useEffect, useRef } from "react";

export default function useEffectIfConditionAfterDelay(
  effect: () => void,
  condition: boolean,
  delay: number
) {
  const timeoutRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    if (condition && !timeoutRef.current) {
      timeoutRef.current = setTimeout(() => {
        if (condition) {
          effect();
        }
      }, delay);

      return () => clearTimeout(timeoutRef.current!);
    }
  }, [condition, effect, delay]);
}
